<template>
    <div class="textToSpeech">
        <div class="start" v-if="!enabled" @click="start()"></div>
        <div class="stop" v-if="enabled" @click="stop()"></div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'TextToSpeech',
    props: {
        volume: {
            type: Number,
            default: 1
        },
        lang: {
            type: String,
            default: 'it-IT'
        },
        persons: {
            type: Array,
            default: function () {
                return [
                    // Windows
                    'Microsoft Elsa Online (Natural) - Italian (Italy)', 'Microsoft Elsa - Italian (Italy)', 'Microsoft Cosimo - Italian (Italy)',
                    // iPhone
                    'Shelley', 'Sandy', 'Eddy', 'Reed', 'Flo', 'Rocko',
                    // Android
                    'italiano Italia',
                    // Chrome with 200 chars limit, here as fallback
                    'Google italiano',
                ]
            }
        }
    },

    data() {
        return {
            enabled: false,
            synthesising: false,
            speechSynthesis: null,
            voice: null,
            messages: []
        }
    },

    mounted() {
        this.speechSynthesis = window.speechSynthesis;

        this.$root.$on('messages-received', messages => {
            if (this.enabled) {
                this.processMessages(messages);
            }
        });
    },
    methods: {
        processMessages(messages) {
            let converted = messages.map(message => {
                let result = '';
                let content = message.content;
                if (message.type == 'simpleText') {
                    result = content.text;
                } else if (message.type == 'html') {
                    result = content.speech ? content.speech : this.stripHtml(content.html);
                } else if (message.type == 'buttons') {
                    result = content.title + '. ' + content.buttons.map(element => element.title).join('. ');
                } else if (['audio-question', 'video-question', 'rating-question'].includes(message.type)) {
                    result = content.title;
                } else if (['multiple-question', 'single-question'].includes(message.type)) {
                    result = content.title + '. ' + content.choices.map(element => element.label).join('. ');
                }
                return this.removeEmojis(result);
            }).filter(message => Boolean(message));

            this.messages = this.messages.concat(converted);
            while (this.messages.length > 0) {
                this.say(this.messages.shift());
            }
        },

        removeEmojis(text, replace = ' ') {
            var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
            return text.replace(regex, replace);
        },

        stripHtml(html, fallback = '') {
            let element = document.createElement('DIV');
            element.innerHTML = html;
            return element.textContent || element.innerText || fallback;
        },

        utterance(text) {
            let utterance = new SpeechSynthesisUtterance(text);
            utterance.volume = this.volume;
            utterance.lang = this.lang;
            utterance.voice = this.voice;
            utterance.rate = 1;
            utterance.pitch = 1;
            return utterance;
        },

        stop() {
            this.speechSynthesis.cancel();
            this.synthesising = false;
            this.enabled = false;
            this.messages = [];
        },

        start() {
            this.voice = this.voice ? this.voice : this.currentVoice();
            this.enabled = this.voice ? true : false;
            this.iosWorkaround();
        },

        iosWorkaround() {
            // Under iOs speech synthesis must be first triggered by a user interaction
            if (this.enabled) {
                const stub = new SpeechSynthesisUtterance('hi');
                stub.volume = 0; // Nobody will listen
                this.speechSynthesis.speak(stub);
            }
        },

        say(text) {
            this.synthesising = true;
            let utterance = this.utterance(text);
            this.speechSynthesis.speak(utterance);
        },

        currentVoice() {
            let voices = window.speechSynthesis.getVoices();

            let languageVoices = voices.filter(voice => {
                return (voice.lang.toLowerCase() == this.lang.toLowerCase()) || voice.lang.toLowerCase().startsWith(this.lang.toLowerCase() + '-');
            });

            let personVoices = this.persons.map(person => {
                return languageVoices.find(voice => {
                    return person.toLowerCase() === voice.name.toLowerCase();
                });
            });

            personVoices = personVoices.filter(voice => voice);

            if (personVoices.length) {
                return personVoices[0];
            }

            if (languageVoices.length) {
                return languageVoices[0];
            }

            return null;
        }
    }
};
</script>

<style lang="scss">
.textToSpeech {
    float: right;
    position: relative;
    cursor: pointer;
    margin-left: 10px;

    &>div {
        display: inline-block;
        vertical-align: middle;
        min-width: 20px;
        min-height: 20px;
        color: #c1c1c1;
        background-repeat: no-repeat;
    }

    .start {
        background-image: url("/frontend/img/ico_volume_slash.svg");
    }

    .stop {
        background-image: url("/frontend/img/ico_volume.svg");
    }
}
</style>

